import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  header: {
    padding: '16px 24px',
    '& .MuiAccordionSummary-content': {
      margin: 0,
    },
  },
  sideBorder: {
    width: 4,
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
    pointerEvents: 'none',
  },
  headerContainer: {
    display: 'grid',
    gridTemplateColumns: '400px 204px 72px',
    justifyContent: 'space-between',
    width: '100%',
    gap: 8,
    alignItems: 'center',
    [theme.breakpoints.down(1170)]: {
      gridTemplateColumns: '1fr 0.6fr 0.4fr',
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr 0.4fr',
      gridTemplateRow: 'auto auto',
      gridTemplateAreas: `
      'content count'
      'status count'
      `,
    },
  },
  headerSubContent: {
    fontWeight: 400,
    lineHeight: '16px',
  },
  headerAction: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      gridArea: 'count',
    },
  },
  headerArrow: {
    [theme.breakpoints.down('sm')]: {
      transform: 'rotate(-90deg)',
    },
  },
  counterWrapper: {
    padding: '4px 13px',
    borderRadius: 16,
    marginRight: 8,
  },
  fileContent: {
    [theme.breakpoints.down('sm')]: {
      gridArea: 'content',
    },
  },
  fileStatus: {
    [theme.breakpoints.down('sm')]: {
      gridArea: 'status',
    },
  },
}))
